import Vue from 'vue';
/**
 * @param  {number} value 单位字节
 * @return {string} 参数值
 */
export default Vue.filter('fileSizeKB', function (value: number) {
    if (!value) {
        return '--';
    }
    const result = value / 1024;
    return `${result.toFixed(1)}KB`;
});
